var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('LogoBar',{attrs:{"loading":_vm.loading,"data":_vm.data}}),_vm._v(" "),_c('HeaderMenu',{staticClass:"d-none d-md-block",attrs:{"loading":_vm.loading,"data":_vm.data}})],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }